module.exports = __webpack_public_path__ + "b5581fb616eff905bdf3accc0c0ef326.png";